// app/hermes/app-src-react/lib/auth.js
import React, { memo } from 'react';
import Backdrop from '@mui/material/Backdrop';

export const AuthLoadingBackdrop = () => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
    />
  );
}
